import classnames from 'classnames';
import type FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import getFocusedFilterForTable from 'mini-mail-list-store/lib/utils/getFocusedFilterForTable';
import getSelectedTableView from 'mini-mail-list-store/lib/utils/getSelectedTableView';
import React from 'react';
import strings from 'owa-strings/owa-mini-strings';
import styles from './MailListViewSecondaryHeader.scss';
import { BinarySwitch } from 'mini-binary-switch';
import { getStore as getMailStore } from 'owa-mail-store/lib/store/Store';
import { Header } from 'mini-header';
import { MailListFilterButton } from 'mini-mail-list-filter';
import { observer } from 'mobx-react-lite';
import { shouldShowMailListHeaderForFolderId } from '../utils/mailList/shouldShowMailListHeaderForFolderId';
import { shouldShowThemeHeroImage } from '../utils/mailList/shouldShowThemeHeroImage';
import { useOnToggleFocusedOther } from 'mini-mail-focused-inbox-rollup-view/lib/hooks/useOnToggleFocusedOther';
import type { TableView } from 'mini-mail-prefetch';
import {
    EmptyFolderButton,
    shouldShowEmptyFolderButtonForFolderId,
} from 'mini-mail-empty-folder-button';

const MailListViewSecondaryHeader = props => {
    const selectedTableView: TableView = getSelectedTableView();
    const { forwardedRefs } = props;
    const onToggleFocusedOther = useOnToggleFocusedOther();
    const showThemeHeroImage = shouldShowThemeHeroImage();
    const heroImageClass = { [styles.themeHeroImage]: showThemeHeroImage };

    const folderId: string = selectedTableView?.tableQuery
        ? selectedTableView.tableQuery.folderId
        : null;
    const selectedFocusedFilter = selectedTableView
        ? getFocusedFilterForTable(selectedTableView)
        : -1;

    const isShowingEmptyFolderButton: boolean = shouldShowEmptyFolderButtonForFolderId(folderId);
    const isDisablingEmptyFolderButton =
        !getMailStore().folders?.folderTable?.get(folderId)?.TotalCount;

    const leftContent = isShowingEmptyFolderButton ? (
        <EmptyFolderButton
            folderId={folderId}
            isDisabled={isDisablingEmptyFolderButton}
            className={styles.headerButton}
        />
    ) : (
        <BinarySwitch
            leftLabel={strings.focusFolderLabel}
            rightLabel={strings.otherFolderLabel}
            isLeftSelected={selectedFocusedFilter === 0}
            onClick={onToggleFocusedOther}
            getAriaLabel={(isFocusedSelected: boolean) =>
                isFocusedSelected
                    ? strings.focusFolderSelectedAriaLabel
                    : strings.otherFolderSelectedAriaLabel
            }
            ref={forwardedRefs?.switchRef}
            className={classnames(styles.focusedOther, heroImageClass)}
            freeButtonClass={classnames(styles.focusedOtherUnSelected, heroImageClass)}
            selectedButtonClass={classnames(styles.focusedOtherSelected, heroImageClass)}
        />
    );

    const rightContent = (
        <MailListFilterButton
            selectedTableView={selectedTableView}
            filterRef={forwardedRefs?.filterRef}
            className={classnames(styles.headerButton, heroImageClass)}
        />
    );

    return shouldShowMailListHeaderForFolderId(folderId) ? (
        <Header
            leftContent={leftContent}
            rightContent={rightContent}
            className={classnames(styles.secondaryHeader, heroImageClass)}
            transparent={!!showThemeHeroImage}
        />
    ) : null;
};

export default observer(MailListViewSecondaryHeader);
